import { z } from 'zod';
import { c } from '../contract';

export const authRouter = c.router(
  {
    refresh: {
      summary: 'Refresh auth tokens',
      method: 'POST',
      path: '/refresh',
      body: z.object({
        idToken: z.string(),
      }),
      responses: {
        200: z.object({
          newIdToken: z.string(),
          expirationEpochMs: z.number(),
        }),
        422: z.literal('Unprocessable Entity'),
      },
    },
  },
  { pathPrefix: '/auth' },
);
